import * as Sentry from '@sentry/react';

const packageJson = require('../../package.json');

const initSentry = ({ brand }) => {
  Sentry.init({
    dsn: 'https://f1e31994e17a6c326de71d55023e0b58@o4509545938223104.ingest.us.sentry.io/4509823041142784',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error', 'info'] })
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
    normalizeDepth: 10,
    beforeSendSpan(span) {
      span.data = {
        ...span.data,
        brand
      };
      return span;
    },
    beforeSendLog: (log) => {
      const currentSpan = Sentry.getActiveSpan();
      if (currentSpan) {
        log.attributes = {
          ...log.attributes,
          ...currentSpan,
          brand
        };
      }

      return log;
    },
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV,
    release: `${brand}@${packageJson.version}`
  });
};

export { initSentry };
